import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import WaitingPlayerCard from './WaitingPlayerCard';
import { buildQueueSections } from '../utils/queue';
import { getPlayerPoints } from '../utils/points';

export function PlayersQueue() {
  const players = useSelector((state) => state.players);

  const totalPlayers = players.filter((p) => p.checkedIn).length;

  // Seções na ordem da fila (prioridade no topo, depois esperas desc, check-in no fim).
  const sections = buildQueueSections(players);

  return (
    <Box
      sx={{
        mt: 4,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h5" textAlign="center">
        {`${totalPlayers} jogadores em quadra:`}
      </Typography>
      <Box
        sx={{
          mt: 2,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 2,
          px: { xs: 2, md: 2 },
        }}
      >
        {sections.length > 0
          ? sections.map((section) => (
            <Box
              key={section.key}
              sx={{
                width: '100%',
                bgcolor: 'rgba(255, 255, 255, 0.55)',
                border: '1px solid rgba(0, 0, 0, 0.06)',
                borderRadius: 3,
                p: 2,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, mb: 1, textAlign: 'center' }}
              >
                {section.key === 'priority'
                  ? `${section.title} (${section.players.reduce((sum, p) => sum + getPlayerPoints(p), 0)})`
                  : section.title}
              </Typography>
              <Box sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', pl: { xs: 1, md: 2 },
              }}
              >
                {section.players.map((player) => (
                  <WaitingPlayerCard key={`${player.playerId}-${player.playerName}`} player={player} fullWidth />
                ))}
              </Box>
            </Box>
          ))
          : <Typography textAlign="center">Nenhum jogador em quadra</Typography>}
      </Box>
    </Box>
  );
}
